// import { IntercomIdentifier } from '@gik/analytics/hooks/IntercomIdentifier';
import { useIntercomStore } from '@gik/ui/gik/IntercomLazyProvider/IntercomStore';
import React from 'react';
// import { AppHeader } from '../AppHeader';
import { useIntercom } from 'react-use-intercom';
import { useUserStore } from '@gik/core/store/UserStore';
import { dotnetApi } from '@gik/core/api/ky/dotnetApi';
import { logger } from '@gik/analytics/utils/logger';

export type IntercomLazyProviderProps = {};

export function IntercomLazyProvider({ children }: React.PropsWithChildren<IntercomLazyProviderProps>) {
  const { boot } = useIntercom();
  const userId = useUserStore(state => state.id);

  React.useEffect(() => {
    boot();
    useIntercomStore.getState().setBooted();
  }, [boot]);

  React.useEffect(() => {
    const cleanUp = () => {
      window.intercomSettings.user_id = null;
      window.intercomSettings.email = null;
      window.intercomSettings.user_hash = null;
    };

    if (userId) {
      (async () => {
        try {
          const response = await dotnetApi
            .get(`users/${userId}/intercom-hash`)
            .json<{ hash: string; emailAddress: string }>();

          window.intercomSettings.user_id = userId;
          window.intercomSettings.email = response.emailAddress;
          window.intercomSettings.user_hash = response.hash;
        } catch (e) {
          logger.error('IntercomLazyProvider Error: Could not hash user id', e.message);
        }
      })();
    } else {
      cleanUp();
    }

    return cleanUp;
  }, [userId]);

  return <>{children}</>;
}
